import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		isMobile: /(iPhone|iPad|Android)/gi.test(navigator.userAgent),
		moveUp: false,
	},
	mutations: {
		watchScroll(state, payload) {
			state.moveUp = payload;
		},
	},
});
